import React from 'react';
import { Box, ToggleButton, Typography } from '@mui/material';
import TranslationHelper from '../../helpers/TranslationHelper';

interface IToggleButtonWithErrorProps {
    value: string;
    labelKey: string;
    hasError: boolean;
    disabled?: boolean;
}

const ToggleButtonWithError = ({
    value,
    labelKey,
    hasError,
    disabled,
}: IToggleButtonWithErrorProps) => (
    <ToggleButton value={value} disabled={disabled}>
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Typography variant="body1">
                {TranslationHelper.translate(labelKey)}
            </Typography>
            {hasError && (
                <Typography variant="caption" color="error">
                    {TranslationHelper.translate('Form contains errors')}
                </Typography>
            )}
        </Box>
    </ToggleButton>
);

export default ToggleButtonWithError;
